export default function EligibilitySection() {
  return (
    <section id="eligibility" className="py-16 bg-gradient-to-br from-slate-800 to-slate-900 scroll-mt-20" aria-labelledby="eligibility-heading">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 id="eligibility-heading" className="text-2xl md:text-3xl font-bold text-white mb-3">
            Online Loan Eligibility Calculator
          </h2>
          <p className="text-slate-300 max-w-2xl mx-auto">
            Check your loan eligibility for SBI, HDFC, and Axis Bank. Our tool helps you calculate EMIs for 5 lakh personal loans, used car loans from HDFC, and even simple interest gold loans.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-10">
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-6 text-center">
            <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-white font-semibold mb-2">Compare Bank Rates Instantly</h3>
            <p className="text-slate-400 text-sm">Side-by-side comparison of interest rates from India's top banks including HDFC, SBI, ICICI, and Axis Bank.</p>
          </div>

          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-6 text-center">
            <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-white font-semibold mb-2">Full Amortization Schedule</h3>
            <p className="text-slate-400 text-sm">Get a complete monthly/yearly breakdown showing how your loan balance reduces over time with each EMI payment.</p>
          </div>

          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-6 text-center">
            <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-white font-semibold mb-2">Calculate Eligibility</h3>
            <p className="text-slate-400 text-sm">Understand your borrowing capacity based on income, existing obligations, and bank-specific criteria for SBI, HDFC, and Axis.</p>
          </div>
        </div>

        <div className="text-center">
          <a
            href="#calculator"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-xl shadow-lg shadow-blue-600/20 transition-all hover:shadow-blue-600/30 hover:-translate-y-0.5 text-lg"
          >
            Start Calculating Now
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  )
}
